import React, { useRef, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// import { CMP_COLOR_UI_PRODUCT_TILE_SURFACE_ICON_BUTTON_DEFAULT_DARK } from '@oneaudi/unified-web-common';
import { Text } from '@oneaudi/unified-web-components';
import type { VinAudiCodeProps } from '../../types';
// import InfoIcon from '../../assets/icons/InfoIcon';
import {
  AudiCodeContainer,
  AudiCode,
  VinWrapper,
  Vin,
  CodeWrapper,
  AudiCodeWrapper,
  // StyledInfoButton,
} from './VinAudiCode.styles';

const VinAudiCode: React.FC<VinAudiCodeProps> = ({ vin, oaddStockNumber, modelMake }) => {
  const targetRef = useRef(null);
  const { t } = useTranslation();
  // const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  // const handlePopoverToggle = () => {
  //   setIsPopoverOpen(!isPopoverOpen);
  // };

  // const handleClose = () => {
  //   setIsPopoverOpen(false);
  // };
  return (
    <AudiCodeContainer data-testid="audi-code-container">
      <CodeWrapper>
        <VinWrapper>
          <Text margin={[0, '6px', 0, 0]}>{t('vehiclePricingBar.dealerListPrice.vin')}</Text>
          <Vin data-vehicle-vin={vin} data-testid="vin">
            {vin}
          </Vin>
        </VinWrapper>
        {oaddStockNumber?.length > 0 && (
          <AudiCodeWrapper>
            <Text margin={[0, '6px', 0, 0]}>
              {t('vehiclePricingBar.dealerListPrice.stockNumber')}
            </Text>
            <AudiCode data-testid="audi-code" ref={targetRef}>
              {oaddStockNumber}
            </AudiCode>
          </AudiCodeWrapper>
        )}
        {/* {modelMake === 'AA' && (
          <AudiCodeWrapper>
            <Text margin={[0, '6px', 0, 0]}>{t('vehiclePricingBar.dealerListPrice.audiCode')}</Text>
            <AudiCode data-testid="audi-code" ref={targetRef}>
              {audiCode}
            </AudiCode>
            <Popover
              alignment="left"
              aria-label="audicode info popover trigger"
              content={
                <div className="popover-styles" style={{ width: '250px' }}>
                  <Text
                    tag="label"
                    variant={{
                      type: 'copy',
                      order: '1',
                      style: 'short',
                    }}
                  >
                    {t('vehiclePricingBar.dealerListPrice.audiCodeInfoPopup.copy')}
                  </Text>
                </div>
              }
              data-testid="popover-trigger"
              id="popover-price-id"
              onClose={handleClose}
              placement="bottom"
              targetRef={targetRef}
              triggerElement={
                <StyledInfoButton
                  ref={targetRef}
                  onClick={handlePopoverToggle}
                  aria-label="audicode info popover trigger"
                  data-testid="popover-trigger"
                  type="button"
                >
                  <InfoIcon
                    color={CMP_COLOR_UI_PRODUCT_TILE_SURFACE_ICON_BUTTON_DEFAULT_DARK}
                    size={24}
                  />
                </StyledInfoButton>
              }
              withTip
              open={isPopoverOpen}
            />
          </AudiCodeWrapper>
        )} */}
      </CodeWrapper>
    </AudiCodeContainer>
  );
};

export default VinAudiCode;
